import utility from "src/utils/utility"
import { useSearchParams } from "react-router-dom"
import {SigninV1, SigninV2} from 'src/app/preAuth/signin/types'

const SignIn: React.FC = () => {
    const [searchParams] = useSearchParams()
    const ssoToken = searchParams.get('sso_token')

    return (
        !ssoToken ? <SigninV1 /> : <SigninV2 token={ssoToken} />
    )
}

export default utility.routeData('/login', 'Login', <SignIn/>)